/*
* This code is the intellectual property of Bulb Inc. and other software publishers;
* it may not be altered, copied or disclosed without prior written approval.
* Copyright 2022, Bulb Inc. For more information, please email contact@hellobulb.com.
*/

import {
  Component, EventEmitter, Input, Output,
} from '@angular/core';
import { MenuItem, MenuItemClickEvent } from '../types';

@Component({
  selector: 'bulb-menubar-item',
  templateUrl: './menubar-item.component.html',
  styleUrls: ['./menubar-item.component.scss'],
  standalone: false,
})
export class MenubarItemComponent {
  @Input() menuItem: MenuItem;

  @Output() menuItemClicked: EventEmitter<MenuItemClickEvent> = new EventEmitter<MenuItemClickEvent>();
}
